import { Check } from "lucide-react";
import Button from "../common/Button";
import AlertDialogSlide from "../common/AlertDialog";
import { useState } from "react";

const PlanCard = ({
  name,
  price,
  description,
  features,
  featured = false,
  current = false,
  onConfirm,
}) => {
  const [open, setOpen] = useState(false);
  
  const minFeaturesHeight = Math.max(features.length * 28, 120); // 28px per feature, min 120px
  
  return (
    <div
      className={`flex flex-col h-full border rounded-xl p-6 transition-all duration-300 ${
        current
          ? "border-primary-300 bg-primary-50 shadow-lg scale-105"
          : "border-gray-200 hover:border-primary-200 hover:shadow-xl"
      } ${current ? "ring-2 ring-primary-500" : ""}`}
    >
      {/* Header Section */}
      <div className="flex-shrink-0 mb-6">
        {featured && (
          <div className="bg-primary-600 text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-4">
            MOST POPULAR
          </div>
        )}
        <h4 className="text-xl font-bold text-secondary-900 mb-2">{name}</h4>
        <div className="mb-3">
          <span className="text-3xl font-bold text-secondary-900">${price}</span>
          <span className="text-secondary-600">/month</span>
        </div>
        <p className="text-secondary-600 text-sm line-clamp-2 min-h-[2.5rem]">
          {description}
        </p>
      </div>

      {/* Features Section with consistent height */}
      <div 
        className="flex-1 mb-6"
        style={{ minHeight: `${minFeaturesHeight}px` }}
      >
        <ul className="space-y-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start space-x-2">
              <Check className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
              <span className="text-secondary-700 text-sm leading-relaxed flex-1">
                {feature}
              </span>
            </li>
          ))}
        </ul>
      </div>

      {/* Button Section - Always at bottom */}
      <div className="flex-shrink-0">
        <AlertDialogSlide
          onConfirm={onConfirm}
          title="Confirm Plan Change"
          description={`Are you sure you want to switch to the ${name} plan? This change will take effect immediately.`}
          open={open}
          setOpen={setOpen}
        >
          <Button
            variant={current ? "primary" : "outline"}
            className="w-full"
            disabled={current}
            onClick={() => setOpen(true)}
            size="lg"
          >
            {current ? "Current Plan" : "Get Started"}
          </Button>
        </AlertDialogSlide>
      </div>
    </div>
  );
};

export default PlanCard;